export const title = 'V-School'
export const description =
  '¡Regresamos con más diversión a tu colegio! Juega ya en V-School, ingresa las claves de tus empaques, participa en nuestros juegos y gana 1 Iphone 14'
